<script setup lang="ts"></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.84614"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M15 23V17H21" />
    <path d="M14.9999 22.9999H3V1H20.9999V16.9999L14.9999 22.9999Z" />
    <path d="M7 6H16.9999" />
    <path d="M7 11H16.9999" />
    <path d="M7 16H11" />
  </svg>
</template>
